const ADDRESSS_HOME = 'HOME';
const ADDRESS_AWAY = 'AWAY';

module.exports = {
  ADDRESSS_HOME,
  ADDRESS_AWAY,
};
